import { api } from "@/lib/api";

export const getBaseOverview = () =>
  api.get("/ecosystems/base").then((r) => r.data);

export const getBaseAssets = (params = {}) =>
  api.get("/ecosystems/base/assets", { params }).then((r) => r.data);

export const getBaseLeaderboard = (params = {}) =>
  api.get("/ecosystems/base/leaderboard", { params }).then((r) => r.data);

export const getBaseHype = (params = {}) =>
  api.get("/ecosystems/base/hype", { params }).then((r) => r.data);

export const getBaseCallers = (params = {}) =>
  api.get("/ecosystems/base/callers", { params }).then((r) => r.data);

export const getBaseMetrics = () =>
  api.get("/ecosystems/base/metrics").then((r) => r.data);

export const getBaseNetwork = () =>
  api.get("/ecosystems/base/network").then((r) => r.data);

export function shortContract(addr) {
  if (addr == null) return "";
  const s = String(addr);
  if (s.length < 12) return s;
  return `${s.slice(0, 6)}…${s.slice(-4)}`;
}

export function explorerAddressUrl(contract) {
  if (!contract) return null;
  return `https://basescan.org/address/${contract}`;
}
